// The topic keys the Employee Reviews API returns, shared by the complete-review wizard
// (which builds a step per topic) and the completed-review view (which renders a snapshot
// per topic) so the two cannot drift apart.

// Matches the backend's ProfileInformationSnapshotBuilder.ProfileInformationTopicKey
// (Employee.Services/EmployeeReview/ProfileInformationSnapshotBuilder.cs).
export const profileInformationTopicKey = "PROFILEINFORMATION";

// Matches the backend's MedicalInformationSnapshotBuilder.MedicalInformationTopicKey.
export const medicalInformationTopicKey = "MEDICALINFORMATION";
